import AccountSummarySortableTableWidget from "../AccountSummarySortableTableWidget";

/**
 * @function AccountSummarySortableTableAssetsAndLoansWidget
 * @return {React.Component}
 * @exported true
 * @description An account summary widget that shows assets and loans in separate sections.
 * It is currently a wrapper of component "AccountSummarySortableTableWidget".
 */
export default function AccountSummarySortableTableAssetsAndLoansWidget(props) {
    return (
        <AccountSummarySortableTableWidget key="accountSummary_2" className="show-on-desktop assets-and-loans" showAssetsAndLoansUI="true" />
    );
}